import { CloseOutlined } from '@ant-design/icons';
import { Drawer } from 'antd';
import styled, { useTheme } from 'styled-components';
import Column from '../../core/components/box/column';
import Row from '../../core/components/box/row';
import SizedBox from '../../core/components/box/sizedBox';
import { LXh4 } from '../../core/texts/lxText';
import TestRequestButtons from './testRequestButtons';

const MenuItem = styled.div`
  height: 40px;
  display: flex;
  align-items: center;

  &:hover {
    background-color: ${(props) => props.theme.colors.grayBgLight};
    border-radius: 4px;
    cursor: pointer;
  }
`;

interface MobileDrawerProps {
  open: boolean;
  onClose: () => void;
}
const MobileDrawer = (props: MobileDrawerProps) => {
  const theme = useTheme();

  const Title = () => (
    <Row justifyContent="flex-end">
      <CloseOutlined onClick={props.onClose} />
    </Row>
  );

  const headerStyle = {
    border: 'none',
    padding: '30px 25px 5px',
  };

  const bodyStye = {
    padding: '0px 25px',
  };

  const items = [
    theme.intro.home,
    theme.intro.search,
    theme.intro.medicalCheckUp,
    theme.intro.notice,
    theme.intro.newsletter,
  ];

  const MenuItems = () => (
    <>
      {items.map((item, index) => (
        <MenuItem key={index}>
          <LXh4 fontWeight={400}>{item}</LXh4>
        </MenuItem>
      ))}
    </>
  );

  return (
    <Drawer
      placement={'bottom'}
      height={360}
      onClose={props.onClose}
      open={props.open}
      closable={false}
      title={<Title />}
      headerStyle={headerStyle}
      bodyStyle={bodyStye}
    >
      <Column>
        <MenuItems />
        <SizedBox height={34} />
        <TestRequestButtons />
      </Column>
    </Drawer>
  );
};

export default MobileDrawer;
